export default __webpack_public_path__ + "static/icon_xichi_green-b84955d9c83928043e09dbd7fbf0f4cb.svg";